/**
 * What the app is called, and what it namespaces its stored data under.
 *
 * Both live here so renaming the project is one edit — `bun run rename
 * <name>` rewrites this file plus the handful of places that can't import
 * it (index.html, public/manifest.webmanifest).
 */

/** Shown in titles, the install offer, and anywhere the app names itself. */
export const SITE_NAME = "Retells";

/**
 * Prefix for every localStorage key, e.g. `template.install.v1`. Namespaced
 * because localStorage is per-origin and a bare `install` key would
 * collide with anything else served from this hostname.
 *
 * The schema version lives in the key, not the payload — a new shape gets
 * `v2` and simply ignores old data, rather than needing a migration.
 */
export const STORAGE_PREFIX = "retells";

/**
 * The `service` field stamped on every log event — the tier identifier ops
 * filters on, pinned by the `/api/log` ingest schema's `z.literal` so an
 * unauthenticated caller can't forge traffic under the project's name (see
 * apps/retells/worker/api-log.ts).
 *
 * NOT derived from STORAGE_PREFIX, and not suffixed `-web`. Three places have
 * to agree on this exact string and only one of them is TypeScript this file
 * can reach:
 *
 *   - the ingest route's `service: z.literal("retells")` (worker/api-log.ts),
 *   - the Convex edge's own `SERVICE_NAME`
 *     (packages/convex/convex/lib/logEvent.ts),
 *   - and the ops queries in docs/ops/logging.md.
 *
 * A mismatch is silent in the worst way: the browser keeps emitting, the route
 * keeps answering 2xx, and every client event is dropped by the schema before
 * it reaches Axiom. Both tiers deliberately share ONE service name — retells
 * ingests into read-by-ear's dataset, where `service` is the discriminator
 * between apps, not between tiers of one app.
 */
export const LOG_SERVICE_NAME = "retells";
